import { EventEmitter } from 'modules/event-emitter';

interface Events {
  onToggleCollapse: { componentID: string; value: boolean };
}
export const navigationEmitter = new EventEmitter<Events>();
